import {
  Box,
  Button,
  Flex,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  Tooltip,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
// import { useInvoices } from '../../services/hooks/useInvoices';
import { formatCustomDate } from '../../utils/formatCustomDate';
import formatValue from '../../utils/formatValue';
import InvoiceModal from '../InvoiceModal';
import ScrollTable from '../shared/ScrollTable';

const statusFin = [
  '',
  'Em Aberto',
  'Liquidado',
  'Renegociado',
  'Baixado',
  'Devolvido',
  'Compensado',
  'Repassado',
  'Depositado',
  'Baixa de Adiantamento',
  'Aguardando Compensação',
  'Bloqueado',
  'Cancelado',
  'Troca',
  'Venda Futura',
];

interface IInvoicesModal {
  isOpen: boolean;
  onClose: any;
}

const InvoicesModal: React.FC<IInvoicesModal> = ({ isOpen, onClose }) => {
  // dados
  // const { data: useInvoicesData } = useInvoices();
  const useInvoicesData = [];
  const [invoicesData, setInvoicesData] = useState(useInvoicesData);

  // estados
  const [documento, setDocumento] = useState<any>(null);
  const [vencimentoMaisAntigo, setVencimentoMaisAntigo] = useState<any>(null);
  const [invoiceOpen, setInvoiceOpen] = useState(false);

  // estilos
  const bg = useColorModeValue('white', 'gray.800');

  const toast = useToast();

  /*
   * Abrir fatura
   */
  const handleOpenInvoice = (documento: any) => {
    const documentoData = invoicesData?.find(
      item => item.id_fin === documento.id,
    );
    setDocumento(documentoData);
    setInvoiceOpen(true);
  };

  /*
   * Seta a fatura mais antiga
   */
  // useEffect(() => {
  //   setInvoicesData(useInvoicesData);
  //   const faturasAbertas = invoicesData?.filter(
  //     fatura => fatura?.status_fin === '1',
  //   );
  //   if (faturasAbertas && faturasAbertas.length > 0) {
  //     const maisAntiga = faturasAbertas?.reduce((antiga, atual) => {
  //       return new Date(atual?.vencimento_fin) <
  //         new Date(antiga?.vencimento_fin)
  //         ? atual
  //         : antiga;
  //     });
  //     setVencimentoMaisAntigo(maisAntiga?.documento_fin);
  //   }
  // }, [useInvoicesData]);

  /*
   * Pega os dados das faturas para a tabela
   */
  const getInvoicesData = () => {
    const data = invoicesData;
    const rows: any = [];
    data?.forEach(item => {
      rows.push({
        id: item.id_fin,
        status: statusFin[Number(item.status_fin)],
        documento: item.documento_fin,
        vencimento: formatCustomDate(
          item.vencimento_fin,
          'yyyy-MM-dd HH:mm:ss',
          'dd/MM/yyyy',
        ),
        pagamento: formatCustomDate(
          item.baixa_fin,
          'yyyy-MM-dd HH:mm:ss',
          'dd/MM/yyyy',
        ),
        valorBruto: formatValue(item.valor_fin ?? '0'),
        valorMulta: formatValue(item.valormulta_fin ?? '0'),
        valorJuro: formatValue(item.valorjuro_fin ?? '0'),
        valorLiquido: formatValue(item.saldo_fin ?? '0'),
      });
    });
    return rows;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'DOCUMENTO',
        accessor: 'documento',
      },
      {
        Header: 'VENCIMENTO',
        accessor: 'vencimento',
        Cell: ({ row }: { row: any }) => {
          const color = useColorModeValue('gray.700', 'white');
          return (
            <Flex>
              <Text color={color}>{row.original.vencimento}</Text>
            </Flex>
          );
        },
      },
      {
        Header: 'VALOR BRUTO',
        accessor: 'valorBruto',
      },
      {
        Header: 'VALOR MULTA',
        accessor: 'valorMulta',
      },
      {
        Header: 'VALOR JURO',
        accessor: 'valorJuro',
      },
      {
        Header: 'VALOR LIQUIDO',
        accessor: 'valorLiquido',
      },
      {
        Header: 'PAGAMENTO',
        accessor: 'pagamento',
      },
      {
        Header: 'STATUS',
        accessor: 'status',
      },
      {
        Header: 'AÇÕES',
        accessor: 'acoes',
        Cell: ({ row }: { row: any }) => {
          return (
            <Flex w="min-content">
              <Tooltip label="" hasArrow placement="top">
                <Button
                  size="sm"
                  variant={
                    row.original.status === 'Em Aberto' ? 'solid' : 'outline'
                  }
                  colorScheme={
                    row.original.status === 'Em Aberto' ? 'green' : 'blue'
                  }
                  onClick={() => {
                    if (row.original.status === 'Em Aberto') {
                      handleOpenInvoice(row.original);
                    } else {
                      toast({
                        title: 'Fatura não disponivel',
                        status: 'info',
                        isClosable: true,
                        position: 'bottom-right',
                      });
                    }
                  }}
                >
                  Ver Fatura
                </Button>
              </Tooltip>
            </Flex>
          );
        },
      },
    ],
    [],
  );

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="100px">
      <ModalOverlay />
      <ModalContent
        borderWidth="1px"
        rounded="2xl"
        p="4"
        px="8"
        w="65%"
        h="90vh"
        overflowY="auto"
        bg={bg}
        sx={{
          '&::-webkit-scrollbar': {
            width: '7px',
            background: 'none',
          },
          '&::-webkit-scrollbar-track': {
            background: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'gray.500',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'gray.400',
          },
        }}
      >
        <ModalCloseButton onClick={onClose} />
        <Text fontSize="2xl">Faturas</Text>
        <Flex flexDir="column" w="100%" rounded="2xl" bg={bg}>
          <ScrollTable columns={columns} data={getInvoicesData()} />
        </Flex>
      </ModalContent>
      <InvoiceModal
        onClose={() => setInvoiceOpen(false)}
        isOpen={invoiceOpen}
        size="100vw"
        documento={documento}
        vencimentoMaisAntigo={vencimentoMaisAntigo}
      />
    </Modal>
  );
};

export default InvoicesModal;
